import React from 'react';
import { MappingGoal, MappingCounts } from './mappingTypes';
import { GOAL_EMOJIS, getMappingStyles } from './mappingStyles';
import { useDarkMode } from '../../../context/DarkModeContext';

interface GoalListProps {
  goals: MappingGoal[];
  selectedGoalId: string | null;
  mappingCounts: MappingCounts;
  onGoalSelect: (goalId: string) => void;
  className?: string;
}

const GoalList: React.FC<GoalListProps> = ({
  goals,
  selectedGoalId,
  mappingCounts,
  onGoalSelect,
  className = ''
}) => {
  const { darkMode } = useDarkMode();
  const styles = getMappingStyles(darkMode);

  return (
    <div className={`${styles.sectionBg} rounded-lg p-4 ${className}`}>
      <h3 className={`text-base font-semibold ${styles.textColor} mb-4`}>Your Goals</h3>
      <div className="space-y-2">
        {goals.map(goal => {
          const mappingCount = mappingCounts[goal.id] || 0;
          const isSelected = selectedGoalId === goal.id;
          
          return (
            <button
              key={goal.id}
              onClick={() => onGoalSelect(goal.id)}
              className={`w-full text-left p-3 rounded-lg transition-all ${
                isSelected 
                  ? `${styles.activeCardBg} border-2 border-blue-500` 
                  : `${styles.cardBg} border-2 border-transparent hover:border-gray-600`
              }`}
            >
              <div className="flex items-center gap-2">
                <span className="text-xl">{GOAL_EMOJIS[goal.type] || GOAL_EMOJIS.custom}</span>
                <span className={`${styles.textColor} text-sm`}>{goal.text}</span>
              </div>
              <div className={`text-xs ${styles.mutedTextColor} mt-1 ml-7`}>
                {mappingCount} rubric items connected
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GoalList;